import React from "react";

function WhatsAppIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="25"
      height="25"
      fill="none"
      viewBox="0 0 25 25"
    >
      <path
        fill="#00E510"
        d="M12.652.655h-.054C5.985.655.625 6.017.625 12.632v.054c0 6.614 5.36 11.976 11.973 11.976h.054c6.613 0 11.973-5.362 11.973-11.976v-.054c0-6.615-5.36-11.977-11.973-11.977z"
      ></path>
      <path
        fill="#FDFDFD"
        d="M14.964 16.169a5.58 5.58 0 01-5.571-5.573 1.415 1.415 0 011.646-1.392c.166.028.325.084.47.169a.079.079 0 01.039.056l.324 2.046a.078.078 0 01-.02.066c-.178.199-.407.342-.662.413l-.122.035.046.118a4.156 4.156 0 002.338 2.34l.119.046.034-.122c.072-.255.215-.484.413-.663a.077.077 0 01.053-.02.08.08 0 01.013 0l2.046.325a.081.081 0 01.057.039 1.418 1.418 0 01.189.705c0 .778-.633 1.411-1.412 1.412z"
      ></path>
      <path
        fill="#FDFDFD"
        d="M20.41 11.984a7.54 7.54 0 00-2.414-4.89 7.535 7.535 0 00-5.116-1.998c-4.169 0-7.56 3.393-7.56 7.563 0 1.4.385 2.763 1.116 3.95l-1.63 3.609 5.218-.556a7.492 7.492 0 003.65.518c.235-.025.473-.062.706-.109 3.492-.706 6.04-3.805 6.06-7.372v-.04c0-.227-.01-.455-.03-.675zm-10.185 6.094l-2.887.308.862-1.91-.172-.232a5.986 5.986 0 01-1.183-3.585 6.043 6.043 0 016.035-6.037c3.118 0 5.76 2.434 6.016 5.54a6.192 6.192 0 01.019.641 6.02 6.02 0 01-6.033 5.895 5.969 5.969 0 01-2.547-.566l-.11-.053v-.001z"
      ></path>
    </svg>
  );
}

export default WhatsAppIcon;
